import Vue from 'vue'
import Router from 'vue-router'
import activityRoutes from "./activity"
import copilotRoutes from "./copilot"


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/page/index'),
      meta: {
        title: ''
      }
    },
    {
      path: '/servicehtml/agreementframe',
      name: 'agreementframe',
      component: () => import('@/page/agreementframe'),
      meta: {
        title: '服务协议'
      }
    },
    {
      path: '/servicehtml/privacypolicyframe',
      name: 'privacypolicyframe',
      component: () => import('@/page/privacypolicyframe'),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/servicehtml/member_protocol',
      name: 'member_protocol',
      component: () => import('@/page/member_protocol'),
      meta: {
        title: '会员协议'
      }
    },
    {
      path: '/servicehtml/member_renew',
      name: 'member_renew',
      component: () => import('@/page/member_renew'),
      meta: {
        title: '自动续费服务协议'
      }
    },
    {
      path: '/servicehtml/forcerule',
      name: 'forcerule',
      component: () => import('@/page/forcerule'),
      meta: {
        title: '绿钻转赠规则'
      }
    },
    {
      path: '/servicehtml/faq',
      name: 'faq',
      component: () => import('@/page/faq'),
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/servicehtml/about',
      name: 'about',
      component: () => import('@/page/about'),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/servicehtml/abouttlbc',
      name: 'abouttlbc',
      component: () => import('@/page/abouttlbc'),
      meta: {
        title: '关于TLBC'
      }
    },
    {
      path: '/servicehtml/help_document.html',
      name: 'help_document',
      component: () => import('@/page/help_document'),
      meta: {
        title: '帮助文档'
      }
    },
    {
      path: '/servicehtml/zixun_detail.html',
      name: 'zixun_detail',
      component: () => import('@/page/zixun_detail'),
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/servicehtml/mining.html',
      name: 'mining',
      component: () => import('@/page/mining'),
      meta: {
        title: '采集'
      }
    },
    {
      path: '/servicehtml/writer_list',
      name: 'writer_list',
      component: () => import('@/page/writer_list'),
      meta: {
        title: '陀螺号榜单'
      }
    },
    {
      path: '/servicehtml/gyro_ecology',
      name: 'gyro_ecology',
      component: () => import('@/page/gyro_ecology'),
      meta: {
        title: '陀螺生态'
      }
    },
    {
      path: '/servicehtml/gyro_answer',
      name: 'gyro_answer',
      component: () => import('@/page/gyro_answer'),
      meta: {
        title: ''
      }
    },
    {
      path: '/servicehtml/estate_blockchain_detail',
      name: 'estate_blockchain_detail',
      component: () => import('@/page/estate_blockchain_detail'),
      meta: {
        title: '产业区块链'
      }
    },
    {
      path: '/servicehtml/annual_report',
      name: 'annual_report',
      component: () => import('@/page/annual_report.vue'),
      meta: {
        title: '年度报告'
      }
    },
    {
      path: '/circle/comm_index',
      name: 'comm_index',
      component: () => import('@/page/circle/comm_index'),
      meta: {
        title: '圈子首页'
      }
    },
    {
      path: '/circle/create',
      name: 'circle_create',
      component: () => import('@/page/circle/create_circle'),
      meta: {
        title: '创建圈子'
      }
    },
    {
      path: '/circle/index',
      name: 'circle_index',
      component: () => import('@/page/circle/index'),
      meta: {
        title: '圈子主页'
      }
    },
    {
      path: '/circle/wait',
      name: 'circle_wait',
      component: () => import('@/page/circle/wait_answer'),
      meta: {
        title: '待我回答'
      }
    },
    {
      path: '/circle/detail',
      name: 'circle_detail',
      component: () => import('@/page/circle/circle_detail'),
      meta: {
        title: '圈子详情'
      }
    },
    {
      path: '/dynamic/detail',
      name: 'dynamic_detail',
      component: () => import('@/page/circle/dynamic_detail'),
      meta: {
        title: '动态详情'
      }
    },
    {
      path: '/circle/share',
      name: 'circle_share',
      component: () => import('@/page/circle/share_poster'),
      meta: {
        title: '圈子二维码'
      }
    },
    {
      path: '/circle/data',
      name: 'circle_data',
      component: () => import('@/page/circle/circle_data'),
      meta: {
        title: '圈子资料'
      }
    },
    {
      path: '/circle/edit',
      name: 'circle_edit',
      component: () => import('@/page/circle/circle_edit'),
      meta: {
        title: '编辑资料'
      }
    },
    {
      path: '/circle/member',
      name: 'circle_member',
      component: () => import('@/page/circle/circle_member'),
      meta: {
        title: '圈子成员'
      }
    },
    {
      path: '/circle/joinSetting',
      name: 'join_admin',
      component: () => import('@/page/circle/join_admin'),
      meta: {
        title: '入圈管理'
      }
    },
    {
      path: '/circle/columnSetting',
      name: 'column_setting',
      component: () => import('@/page/circle/column_setting'),
      meta: {
        title: '栏目管理'
      }
    },
    {
      path: '/profit/index',
      name: 'profit_index',
      component: () => import('@/page/profit/index'),
      meta: {
        title: '收益'
      }
    },
    {
      path: '/profit/record',
      name: 'profit_record',
      component: () => import('@/page/profit/record'),
      meta: {
        title: '收益记录'
      }
    },
    {
      path: '/profit/realname',
      name: 'profit_realname',
      component: () => import('@/page/profit/real_name'),
      meta: {
        title: '实名认证'
      }
    },
    {
      path: '/punch/index',
      name: 'punch_index',
      component: () => import('@/page/circle/punch'),
      meta: {
        title: '全部打卡挑战'
      }
    },
    {
      path: '/punch/create',
      name: 'punch_create',
      component: () => import('@/page/circle/create_punch'),
      meta: {
        title: '创建打卡挑战'
      }
    },
    {
      path: '/punch/desc',
      name: 'punch_desc',
      component: () => import('@/page/circle/punch_desc'),
      meta: {
        title: '打卡挑战信息'
      }
    },
    {
      path: '/punch/ranking',
      name: 'punch_ranking',
      component: () => import('@/page/circle/punch_ranking'),
      meta: {
        title: '打卡排行榜'
      }
    },
    {
      path: '/circle/qa',
      name: 'circle_qa',
      component: () => import('@/page/circle/circle_qa'),
      meta: {
        title: '问答'
      }
    },
    {
      path: '/punch/detail',
      name: 'punch_detail',
      component: () => import('@/page/circle/punch_detail'),
      meta: {
        title: '详情'
      }
    },
    {
      path: '/publish',
      name: 'publish',
      component: () => import('@/page/circle/publish'),
      meta: {
        title: '发帖'
      }
    },
    {
      path: '/circle/block',
      name: 'circle_block',
      component: () => import('@/page/circle/block'),
      meta: {
        title: '屏蔽管理'
      }
    },
    {
      path: '/order/list',
      name: 'order_list',
      component: () => import('@/page/circle/order'),
      meta: {
        title: '订单'
      }
    },
    {
      path: '/order/detail',
      name: 'order_detail',
      component: () => import('@/page/circle/order_detail'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/order/pay',
      name: 'order_pay',
      component: () => import('@/page/circle/pay'),
      meta: {
        title: '确认订单'
      }
    },
    {
      path: '/ask/list',
      name: 'ask_list',
      component: () => import('@/page/circle/ask_list'),
      meta: {
        title: '提问列表'
      }
    },
    {
      path: '/medeal/list',
      name: 'medeal_list',
      component: () => import('@/page/medeal_list'),
      meta: {
        title: '我的勋章'
      }
    },
    {
      path: '/medeal/detail',
      name: 'medeal_detail',
      component: () => import('@/page/medeal_detail'),
      meta: {
        title: '我的勋章'
      }
    },
    {
      path: '/video/detail',
      name: 'video_detail',
      component: () => import('@/page/video/detail'),
      meta: {
        title: '视频详情'
      }
    },
    {
      path: '/privacy_authority.html',
      name: 'privacy-authority',
      component: () => import('@/page/introduction/privacy_authority.vue'),
      meta: {
        title: '陀螺科技App申请使用权限列表_陀螺科技'
      }
    },
    {
      path: '/cancellation.html',
      name: 'cancellation',
      component: () => import('@/page/introduction/cancellation.vue'),
      meta: {
        title: '注销协议_陀螺科技'
      }
    },
    {
      path: '/privacy_meizu.html',
      name: 'privacy_meizu',
      component: () => import('@/page/introduction/privacy_meizu.vue'),
      meta: {
        title: '隐私政策_陀螺科技'
      }
    },
    {
      path: '/privacy_sdk.html',
      name: 'privacy-sdk',
      component: () => import('@/page/introduction/privacy_sdk.vue'),
      meta: {
        title: 'App接入第三方SDK目录_陀螺科技'
      }
    },
    {
      path: '/privacy.html',
      name: 'privacy',
      component: () => import('@/page/introduction/privacy.vue'),
      meta: {
        title: '隐私政策_陀螺科技'
      }
    },
    {
      path: '/privacy_collect.html',
      name: 'privacy_collect',
      component: () => import('@/page/introduction/privacy_collect.vue'),
      meta: {
        title: '陀螺科技个人信息收集清单'
      }
    },
    {
      path: '/user/cancellation',
      name: 'user-cancellation',
      component: () => import('@/page/cancellation.vue'),
      meta: {
        title: '账号注销'
      }
    },
    {
      path: '/apple-app-site-association',
      name: 'apple-app-site-association',
      component: () => import('@/page/apple-app-site-association.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/contactUs',
      name: 'contact-us',
      component: () => import('@/page/contactUs.vue'),
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/member',
      name: 'member',
      component: () => import('@/page/member/index.vue'),
      meta: {
        title: '会员'
      },
      children: [{
          path: '/member',
          name: 'member-index',
          component: () => import('@/page/member/index/index.vue'),
          meta: {
            title: '会员',
            keepAlive: true
          },
        },
        {
          path: 'vipPackage',
          name: 'member-vipPackage',
          component: () => import('@/page/member/vipPackage/index.vue'),
          meta: {
            title: '购买会员',
            keepAlive: true
          },
        },
        {
          path: 'user',
          name: 'member-user',
          component: () => import('@/page/member/user/index.vue'),
          meta: {
            title: '已购内容',
            keepAlive: true
          },
        },
        {
          path: 'hotGoods',
          name: 'member-hotGoods',
          component: () => import('@/page/member/hotGoods/index.vue'),
          meta: {
            title: '热门推荐'
          },
        },
        {
          path: 'package/detail',
          name: 'member-package-detail',
          component: () => import('@/page/member/package/detail.vue'),
          meta: {
            title: '会员套餐'
          }
        },
        {
          path: 'forenotice',
          name: 'member-forenotice',
          component: () => import('@/page/member/forenotice/index.vue'),
          meta: {
            title: '活动预告'
          }
        },
        {
          path: 'forenotice/detail/:id',
          name: 'member-forenotice-detail',
          component: () => import('@/page/member/forenotice/detail.vue'),
          meta: {
            title: '活动预告'
          }
        },
        {
          path: 'video',
          name: 'member-video',
          component: () => import('@/page/member/video/index.vue'),
          meta: {
            title: '往期回放'
          }
        },
        {
          path: 'video/detail/:id',
          name: 'member-video-detail',
          component: () => import('@/page/member/video/detail.vue'),
          meta: {
            title: '视频详情'
          }
        },
        {
          path: 'industryData',
          name: 'member-industryData',
          component: () => import('@/page/member/industryData/index.vue'),
          meta: {
            title: '产业数据'
          }
        },
        {
          path: 'industryMap',
          name: 'member-industryMap',
          component: () => import('@/page/member/industryMap/index.vue'),
          meta: {
            title: '产业图谱'
          }
        },
        {
          path: 'industryMap/detail',
          name: 'member-industryMap-detail',
          component: () => import('@/page/member/industryMap/detail.vue'),
          meta: {
            title: '产业图谱详情'
          }
        },
        {
          path: 'industryReport',
          name: 'member-industryReport',
          component: () => import('@/page/member/industryReport/index.vue'),
          meta: {
            title: '产业报告'
          }
        },
        {
          path: 'specialcontribution',
          name: 'member-specialcontribution',
          component: () => import('@/page/member/specialcontribution/index.vue'),
          meta: {
            title: '深见特稿'
          }
        },
        {
          path: 'guidePage',
          name: 'member-guidePage',
          component: () => import('@/page/member/guidePage/guidePage.vue'),
          meta: {
            title: '报告详情'
          }
        },
        {
          path: 'friendAssistance',
          name: 'member-friendAssistance',
          component: () => import('@/page/member/friendAssistance/friendAssistance.vue'),
          meta: {
            title: '好友助力'
          }
        },
        {
          path: 'obtainingReports',
          name: 'member-obtainingReports',
          component: () => import('@/page/member/obtainingReports/obtainingReports.vue'),
          meta: {
            title: '分享获取产业报告'
          }
        },
        {
          path: 'industryReport/detail/:id',
          name: 'member-industryReport-detail',
          component: () => import('@/page/member/industryReport/detail.vue'),
          meta: {
            title: '报告详情'
          }
        },
        {
          path: 'financingDatabase/financingData',
          name: 'member-financingDatabase-financingData',
          component: () => import('@/page/member/financingDatabase/financingData.vue'),
          meta: {
            title: '投融资数据库-融资数据'
          }
        },
        {
          path: 'financingDatabase/financingData/detail',
          name: 'member-financingDatabase-financingData-detail',
          component: () => import('@/page/member/financingDatabase/financingData-detail.vue'),
          meta: {
            title: '投融资数据库-融资数据-详情'
          }
        },
        {
          path: 'financingDatabase/financingAnalysis',
          name: 'member-financingDatabase-financingAnalysis',
          component: () => import('@/page/member/financingDatabase/financingAnalysis.vue'),
          meta: {
            title: '投融资数据库-融资分析'
          }
        },
        {
          path: 'investorsPool',
          name: 'member-investorsPool',
          component: () => import('@/page/member/investorsPool/index.vue'),
          meta: {
            title: '投融资机构库'
          }
        },
        {
          path: 'investorsPool/detail/:id',
          name: 'member-investorsPool-detail',
          component: () => import('@/page/member/investorsPool/detail.vue'),
          meta: {
            title: '机构详情'
          }
        },
        {
          path: 'xrHardwareProduct',
          name: 'member-xrHardwareProduct',
          component: () => import('@/page/member/xrHardwareProduct/index.vue'),
          meta: {
            title: 'XR硬件产品库-产品列表'
          }
        },
        {
          path: 'xrHardwareProduct/detail/:id',
          name: 'member-xrHardwareProduct-detail',
          component: () => import('@/page/member/xrHardwareProduct/detail.vue'),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: 'supplyChain',
          name: 'member-supplyChain',
          component: () => import('@/page/member/supplyChain/index.vue'),
          meta: {
            title: '底层供应链'
          }
        },
        {
          path: 'supplyChain/detail',
          name: 'member-supplyChain-detail',
          component: () => import('@/page/member/supplyChain/detail.vue'),
          meta: {
            title: '底层供应链详情'
          }
        },
        {
          path: 'visionProPool',
          name: 'member-visionProPool',
          component: () => import('@/page/member/visionProPool/index.vue'),
          meta: {
            title: 'Vision Pro内容库'
          }
        },
        {
          path: 'visionProPool/detail',
          name: 'member-visionProPool-detail',
          component: () => import('@/page/member/visionProPool/detail.vue'),
          meta: {
            title: 'Vision Pro内容库详情'
          }
        },
        {
          path: 'lbevrPool',
          name: 'member-lbevrPool',
          component: () => import('@/page/member/lbevrPool/index.vue'),
          meta: {
            title: 'LBE VR内容库'
          }
        },
        {
          path: 'lbevrPool/detail',
          name: 'member-lbevrPool-detail',
          component: () => import('@/page/member/lbevrPool/detail.vue'),
          meta: {
            title: 'LBE VR内容库详情'
          }
        },
        {
          path: 'arContentPool',
          name: 'member-arContentPool',
          component: () => import('@/page/member/arContentPool/index.vue'),
          meta: {
            title: 'AR内容库'
          }
        },
        {
          path: 'arContentPool/detail',
          name: 'member-arContentPool-detail',
          component: () => import('@/page/member/arContentPool/detail.vue'),
          meta: {
            title: 'AR内容库详情'
          }
        },
        {
          path: 'vrContentPool',
          name: 'member-vrContentPool',
          component: () => import('@/page/member/vrContentPool/index.vue'),
          meta: {
            title: 'VR内容库'
          }
        },
        {
          path: 'vrContentPool/detail',
          name: 'member-vrContentPool-detail',
          component: () => import('@/page/member/vrContentPool/detail.vue'),
          meta: {
            title: 'VR内容库详情'
          }
        },
        {
          path: 'visionProDevelopPool',
          name: 'member-visionProDevelopPool',
          component: () => import('@/page/member/visionProDevelopPool/index.vue'),
          meta: {
            title: 'Vision Pro开发者库'
          }
        },
        {
          path: 'visionProDevelopPool/detail',
          name: 'member-visionProDevelopPool-detail',
          component: () => import('@/page/member/visionProDevelopPool/detail.vue'),
          meta: {
            title: 'Vision Pro开发者库详情'
          }
        },
        {
          path: 'arContentDevelopPool',
          name: 'member-arContentDevelopPool',
          component: () => import('@/page/member/arContentDevelopPool/index.vue'),
          meta: {
            title: 'AR内容开发者库'
          }
        },
        {
          path: 'arContentDevelopPool/detail',
          name: 'member-arContentDevelopPool-detail',
          component: () => import('@/page/member/arContentDevelopPool/detail.vue'),
          meta: {
            title: 'AR内容开发者库详情'
          }
        },
        {
          path: 'vrGameDevelopPool',
          name: 'member-vrGameDevelopPool',
          component: () => import('@/page/member/vrGameDevelopPool/index.vue'),
          meta: {
            title: 'VR游戏开发者库'
          }
        },
        {
          path: 'vrGameDevelopPool/detail',
          name: 'member-vrGameDevelopPool-detail',
          component: () => import('@/page/member/vrGameDevelopPool/detail.vue'),
          meta: {
            title: 'VR游戏开发者库详情'
          }
        },
        {
          path: 'patentPool',
          name: 'member-patentPool',
          component: () => import('@/page/member/patentPool/index.vue'),
          meta: {
            title: '专利库'
          }
        },
        {
          path: 'patentPool/detail',
          name: 'member-patentPool-detail',
          component: () => import('@/page/member/patentPool/detail.vue'),
          meta: {
            title: '专利库详情'
          }
        },
        {
          path: 'industrialPolicyPool',
          name: 'member-industrialPolicyPool',
          component: () => import('@/page/member/industrialPolicyPool/index.vue'),
          meta: {
            title: '产业政策库'
          }
        },
        {
          path: 'industrialPolicyPool/detail/:id',
          name: 'member-industrialPolicyPool-detail',
          component: () => import('@/page/member/industrialPolicyPool/detail.vue'),
          meta: {
            title: '地区政策汇总'
          }
        },
        {
          path: 'industryNews',
          name: 'member-industryNews',
          component: () => import('@/page/member/industryNews/index.vue'),
          meta: {
            title: '产业大事件'
          }
        },
        {
          path: 'industryNews/hotWords',
          name: 'member-industryNews-hotWords',
          component: () => import('@/page/member/industryNews/hotwords.vue'),
          meta: {
            title: '行业月度热词'
          }
        },
        {
          path: 'order/list',
          name: 'member-order-list',
          component: () => import('@/page/member/order/list.vue'),
          meta: {
            title: '我的订单'
          }
        },
        {
          path: 'order/detail/:id',
          name: 'member-order-detail',
          component: () => import('@/page/member/order/detail.vue'),
          meta: {
            title: '订单详情'
          }
        },
        {
          path: 'order/submit',
          name: 'member-orde-submit',
          component: () => import('@/page/member/order/submit.vue'),
          meta: {
            title: '提交订单'
          }
        },
        {
          path: 'order/invoice',
          name: 'member-orde-invoice',
          component: () => import('@/page/member/order/invoice.vue'),
          meta: {
            title: '申请开票'
          }
        },
        {
          path: 'order/invoice-detail/:id',
          name: 'member-orde-invoice-detail',
          component: () => import('@/page/member/order/invoice-detail.vue'),
          meta: {
            title: '发票详情'
          }
        },
        {
          path: 'order/alipay',
          name: 'member-orde-alipay',
          component: () => import('@/page/member/order/alipay.vue'),
          meta: {
            title: '支付宝支付'
          }
        },
        {
          path: 'agreement',
          name: 'member-agreement',
          component: () => import('@/page/member/agreement/index.vue'),
          meta: {
            title: '支付宝支付'
          }
        },
      ]
    },
    {
      path: '/vote',
      name: 'vote',
      component: () => import('@/page/vote/index.vue'),
      meta: {
        title: '热点投票'
      },
      children: [
        {
          path: '/vote',
          name: 'vote-index',
          component: () => import('@/page/vote/index/index.vue'),
          meta: {
            title: '热点投票',
            keepAlive: true
          },
        },
        {
          path: 'details',
          name: 'vote-details',
          component: () => import('@/page/vote/details/index.vue'),
          meta: {
            title: '热点投票',
          },
        },
      ]
    },
    {
      path: '*',
      name: 'error',
      component: () => import('@/page/error.vue')
    },
    ...activityRoutes,
    ...copilotRoutes
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js